import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useOrg } from "@/lib/states/session/hooks";
import { DialogTitle } from "@radix-ui/react-dialog";
import {
  exerciseDisplayColumns,
  equipmentFilter,
  Exercise,
  experienceFilter,
  muscleGroups,
  typeFilter,
} from "../exercises/exerciseColumns";
import { VirtualizedDataTable } from "../dataTable/VirtualizedDataTable";
import { Button } from "../ui/button";
import { Tables } from "@/lib/supabase/supabaseTypes";
import { trpc } from "@/lib/trpc/client";

interface ExerciseSelectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exerciseSelected: (exercise: Tables<"exercises">) => void;
  createExerciseSelected: () => void;
}

export default function ExerciseSelectDialog({
  open,
  onOpenChange,
  exerciseSelected,
  createExerciseSelected,
}: ExerciseSelectDialogProps) {
  const org = useOrg();
  const { data: exercises } = trpc.exercises.list.useQuery(undefined, {
    enabled: Boolean(org?.id),
  });

  const handleOnOpenChange = (nextOpen: boolean) => {
    onOpenChange(nextOpen);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOnOpenChange}
      analyticsName="exercise_select_dialog"
      modal={true}
    >
      <DialogContent className="min-w-[80vw] h-[80vh] flex flex-col">
        <DialogTitle>
          <h1 className="text-lg">Select Exercise</h1>
        </DialogTitle>

        <VirtualizedDataTable
          columns={exerciseDisplayColumns}
          data={(exercises as Exercise[]) ?? []}
          onRowSelected={(exercise) => {
            exerciseSelected(exercise);
            handleOnOpenChange(false);
          }}
          className="min-h-0 flex-1"
          tableContainerClassName="min-h-0 flex-1"
          tableWrapperClassName="h-full min-h-0"
          virtualizedHeight="100%"
          estimateRowHeight={52}
          tableClassName="min-w-[700px]"
          stickyHeader
          searchBarActions={
            <Button size="sm" onClick={createExerciseSelected}>
              New Exercise
            </Button>
          }
          filterOptions={[
            {
              column: "primary_muscles",
              title: "Muscle groups",
              options: muscleGroups,
            },
            {
              column: "equipment",
              title: "Equipment",
              options: equipmentFilter,
            },
            {
              column: "type",
              title: "Type",
              options: typeFilter,
            },
            {
              column: "experience",
              title: "Experience",
              options: experienceFilter,
            },
          ]}
          toggleFilter={{
            label: "Hide Trainrr Library",
            column: "org_id",
            filterValue: true,
          }}
          showSearchBar
          emptyView={
            <div className="flex flex-col items-center gap-4">
              No exercises found
              <Button onClick={createExerciseSelected} className="w-40">
                Create new exercise
              </Button>
            </div>
          }
        />
      </DialogContent>
    </Dialog>
  );
}
